import Form from './Form';
import FormItem from './FormItem';

Form.Item = FormItem;

export default Form;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/form/index.js
// module id = 384
// module chunks = 0